module.exports = __webpack_public_path__ + "img/jdhd.acebbea0.png";